module.exports = __webpack_public_path__ + "img/Untitled.001.6904b203.jpeg";